/**
 * The highlight color vocabulary, kept free of Tiptap so surfaces that only need to *name* a
 * color — the chat Markdown pipeline, which turns `==text==` into the same `mark` contract —
 * do not pull the editor runtime into their bundle. The mark itself lives in
 * `highlight-mark.ts` and re-exports these.
 */

export const HIGHLIGHT_COLORS = ["yellow", "green", "red"] as const;

export type HighlightColor = (typeof HIGHLIGHT_COLORS)[number];

export const DEFAULT_HIGHLIGHT_COLOR: HighlightColor = "yellow";

/** The rendered color attribute; anything unrecognised (or absent) is the default. */
export function coerceHighlightColor(value: unknown): HighlightColor {
  return HIGHLIGHT_COLORS.includes(value as HighlightColor)
    ? (value as HighlightColor)
    : DEFAULT_HIGHLIGHT_COLOR;
}
